export default __webpack_public_path__ + "static/media/group-7679.bb108303.svg";